import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-social-share',
  templateUrl: './social-share.component.html',
  styleUrls: ['./social-share.component.scss']
})
export class SocialShareComponent implements OnInit {
  @Input() title: string;
  @Input() url: string;
  @Input() showLabel = true;
  @Input() isColumn = false;

  socials = [
    {
      name: 'ВКонтакте',
      url: 'https://vk.com/share.php?url=',
      icon: '/assets/images/social/vk.svg',
      label: 'Поделиться',
      class: 'vk-btn',
      title: null
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/sharer/sharer.php?u=',
      icon: '/assets/images/social/fb.svg',
      label: 'Поделиться',
      class: 'fb-btn',
      title: null
    },
    {
      name: 'Твиттер',
      url: 'https://twitter.com/intent/tweet?url=',
      icon: '/assets/images/social/tw.svg',
      label: 'Твитнуть',
      class: 'tw-btn',
      title: 'text'
    },
    {
      name: 'Одноклассники',
      url: 'https://connect.ok.ru/offer?url=',
      icon: '/assets/images/social/ok.svg',
      label: 'Поделиться',
      class: 'ok-btn',
      title: null
    },
  ];

  constructor(
    private router: Router,
    ) { }

  ngOnInit() {
  }

  getUrl(social: any) {
    return 'https://ветераны.рф' + (this.url ? this.url : this.router.url) + this.getTitle(social);
  }

  private getTitle(social: any): string {
    return social.title ? `&${social.title}=${this.title}` : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/social-share/social-share.component.ts